/**
 * WhatsApp order links ([data-wa-order]) point to wa.me, which opens the
 * WhatsApp app on phones and tablets. On desktop, open WhatsApp Web directly.
 */
(() => {
  if (window.__whatsappOrderReady) return;
  window.__whatsappOrderReady = true;

  const isMobile = () => {
    const ua = navigator.userAgent || '';
    if (/Android|iPhone|iPad|iPod|Mobi|Opera Mini|IEMobile/i.test(ua)) return true;
    // iPadOS reports a desktop Safari user agent
    if (/Macintosh/.test(ua) && navigator.maxTouchPoints > 1) return true;
    return false;
  };

  /** @param {HTMLAnchorElement} link */
  const desktopUrl = (link) =>
    `https://web.whatsapp.com/send?phone=${link.dataset.waPhone}&text=${link.dataset.waText || ''}`;

  /** @param {Event} event */
  const handle = (event) => {
    if (!(event.target instanceof Element)) return;
    const link = event.target.closest('a[data-wa-order]');
    if (!(link instanceof HTMLAnchorElement) || !link.dataset.waPhone) return;
    if (!isMobile()) link.href = desktopUrl(link);
  };

  // Capture phase so the href is updated before the browser follows the link
  document.addEventListener('click', handle, true);
  document.addEventListener('auxclick', handle, true);
})();
